var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoneLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.619C11.25 10.4112 14.8317 7 19.25 7H35.25C39.6683 7 43.25 10.4112 43.25 14.619V47H11.25V14.619Z",
    fill: "#CCE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.25 8.90476H19.25C15.9363 8.90476 13.25 11.4631 13.25 14.619V47H41.25V14.619C41.25 11.4631 38.5637 8.90476 35.25 8.90476ZM19.25 7C14.8317 7 11.25 10.4112 11.25 14.619V47H43.25V14.619C43.25 10.4112 39.6683 7 35.25 7H19.25Z",
    fill: "#ADCCF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9H33.25V10C33.25 11.1046 32.3546 12 31.25 12H23.25C22.1454 12 21.25 11.1046 21.25 10V9Z",
    fill: "#ADCCF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13565_1953)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1847 16.9849C30.4705 16.446 33.8315 16.167 37.2503 16.167C40.6689 16.167 44.0296 16.4459 47.3151 16.9847C50.0995 17.4413 52.0277 20.1613 52.0277 23.2163V32.6647C52.0277 35.7197 50.0995 38.4397 47.3151 38.8963C44.5858 39.3438 41.8045 39.6121 38.9813 39.6901C38.8355 39.6941 38.7021 39.7592 38.6064 39.866L32.7186 43.3777C32.4167 43.7144 31.9627 43.8151 31.5682 43.6329C31.1738 43.4507 30.9166 43.0214 30.9166 42.5452V39.3921C29.6626 39.2641 28.4183 39.0984 27.1847 38.8961C24.4004 38.4394 22.4722 35.7195 22.4722 32.6646V23.2164C22.4722 20.1614 24.4004 17.4415 27.1847 16.9849Z",
    fill: "#1150AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8472 20.9463C39.3839 20.9463 40.6296 22.192 40.6296 23.7287V25.1199H42.3686C42.9449 25.1199 43.412 25.587 43.412 26.1633V33.8148C43.412 34.3911 42.9449 34.8582 42.3686 34.8582H33.3259C32.7496 34.8582 32.2825 34.3911 32.2825 33.8148V26.1633C32.2825 25.587 32.7496 25.1199 33.3259 25.1199H35.0649V23.7287C35.0649 22.192 36.3106 20.9463 37.8472 20.9463ZM37.8473 28.9457C37.2711 28.9457 36.8039 29.4128 36.8039 29.9891C36.8039 30.5653 37.2711 31.0324 37.8473 31.0324C38.4236 31.0324 38.8907 30.5653 38.8907 29.9891C38.8907 29.4128 38.4236 28.9457 37.8473 28.9457ZM37.8472 22.3375C37.0789 22.3375 36.4561 22.9603 36.4561 23.7287V25.1199H39.2384V23.7287C39.2384 22.9603 38.6156 22.3375 37.8472 22.3375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13565_1953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28,
    fill: "white",
    transform: "translate(22.25 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneLock);
export default __webpack_public_path__ + "static/media/icon-phone-lock.be40358a2386e231f85218337130dc66.svg";
export { ForwardRef as ReactComponent };